/* tslint:disable */
/* eslint-disable */

/**
 * Discriminator for client type.
 */
export enum ClientType {
  Company = 'COMPANY',
  LightEntrepreneur = 'LIGHT_ENTREPRENEUR'
}
